var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['status-dot mr-2', { hollow: _vm.hollow }],style:({
    minWidth: `${_vm.size}px`,
    width: `${_vm.size}px`,
    minHeight: `${_vm.size}px`,
    height: `${_vm.size}px`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }